export enum OrderStatus {
  NEW = 'New',
  PROCESSING = 'Processing',
  COMPLETED = 'Completed',
}
